/**
 * Created by yoavp on 12/6/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    var AuditTrailExportModel = {};
    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AuditTrailExportModel = BaseModel.extend({
            resource: ApiResources.AccountConfigExport.AuditTrailExport,
            name: "AuditTrailExportModel"
        });
    }

    LE.module("LEManager", moduleDefinition);

    return AuditTrailExportModel;
});
